import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
const UTILS_URL = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.0/js/utils.js';
/** Always-open international phone input (intl-tel-input) for create forms. */
const PhoneInput = ({ value, onChange, country, placeholder = '' }) => {
    const itiRef = useRef(null);
    const inputRef = useRef(null);
    useEffect(() => {
        const { intlTelInput } = window;
        if (!intlTelInput || !inputRef.current)
            return undefined;
        itiRef.current = intlTelInput(inputRef.current, {
            nationalMode: true,
            autoPlaceholder: 'off',
            initialCountry: (country === null || country === void 0 ? void 0 : country.toLowerCase()) || '',
            preferredCountries: ['be', 'nl', 'fr', 'lu', 'es'],
            utilsScript: UTILS_URL,
        });
        if (value)
            itiRef.current.setNumber(value);
        return () => {
            if (itiRef.current) {
                itiRef.current.destroy();
                itiRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Sync external value changes (e.g. async-loaded data). Skip while the field is focused so a
    // keystroke round-tripping through the parent doesn't re-format the number and move the caret.
    useEffect(() => {
        const el = inputRef.current;
        if (!itiRef.current || !el || document.activeElement === el)
            return;
        const current = itiRef.current.getNumber(1) || el.value || '';
        if ((value || '') !== current)
            itiRef.current.setNumber(value || '');
    }, [value]);
    useEffect(() => {
        if (itiRef.current && country)
            itiRef.current.setCountry(country.toLowerCase());
    }, [country]);
    const handleChange = () => {
        var _a, _b;
        if (itiRef.current) {
            onChange(itiRef.current.getNumber(1) || ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) || '');
        }
        else {
            onChange(((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.value) || '');
        }
    };
    return (_jsx("input", { ref: inputRef, type: "tel", className: "form-control", placeholder: placeholder, autoComplete: "off", onInput: handleChange, onBlur: handleChange }));
};
PhoneInput.defaultProps = {
    country: null,
    placeholder: '',
};
export default PhoneInput;
